<template>
    <el-dialog
      v-model="is_show_dialog"
      title=""
      width="380px"
      class="confirm-dialog"
      :destroy-on-close="true"
    >
      <div class="dialog-content">
        <h2 v-html="props.data.title" style="text-transform: none;"></h2>
        <p v-html="props.data.description"></p>
      </div>
      <div class="dialog-footer">
        <el-button type="text" @click="is_show_dialog = false">{{ props.data.cancel_button_text ? props.data.cancel_button_text : 'Cancel'}}</el-button>
        <el-button type="primary" @click="is_show_dialog = false; props.data.action();">{{ props.data.confirm_button_text ? props.data.confirm_button_text : 'Confirm'}}</el-button>
      </div>
    </el-dialog>
  </template>
  
  <script setup>
    import { ElDialog, ElButton } from 'element-plus';
    import { ref } from 'vue';
    const props = defineProps({
      data: {
        type: Object,
        default: () => ({})
      }
    });

    const is_show_dialog = ref(false);

    const open = () => {
      is_show_dialog.value = true;
    }

    defineExpose({
      open
    });
  </script>
  
  <style lang="scss">
    .confirm-dialog {
      padding: 0;
      overflow: hidden;

      .ui-dialog__header {
        padding: 0 24px;
        display: flex;
        align-items: center;
        height: 40px;

        .ui-dialog__title {
          flex: 1;
          opacity: 0;
        }

        .ui-dialog__close {
          margin: 0;
        }
      }

      .dialog-content {
        padding: 0 24px 24px;
        margin-top: 16px;

        h2 {
          font: var(--demi-20);
          color: var(--Text-primary);
          text-transform: capitalize;
        }

        p {
          font-size: 16px;
          color: var(--Text-secondary);
          margin-top: 12px;
          line-height: 1.4;
        }

      }

      .dialog-footer {
        padding: 8px 24px 24px;
        display: flex;
        justify-content: flex-end;
        align-items: center;

        .el-button--text {
          color: var(--Text-default);
        }

        .el-button {
          margin-left: 8px;
        }
      }
    }
  </style>